import { default as BaseMaskedInput } from 'react-text-mask';
import type { Mask } from 'react-text-mask';

import { Input } from 'ui/input';
import type { InputBaseProps, InputNameProps } from 'ui/input';

import * as masks from 'constants/forms-validaition';

type MaskedInputProps = Omit<
  InputBaseProps,
  'value' | 'defaultValue' | 'onChange' | 'onBlur' | 'ref'
> &
  InputNameProps & {
    value?: string;
    mask: string;
    showMask?: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  };

type MaskRender = (
  ref: (input: HTMLInputElement | null) => void,
  inputProps: {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  }
) => React.JSX.Element;

const MaskedInput = ({
  value,
  mask,
  showMask = true,
  onChange,
  onBlur,
  ...props
}: MaskedInputProps) => (
  <BaseMaskedInput
    mask={(masks as Record<string, Mask>)[mask]}
    showMask={showMask}
    guide={showMask}
    render={
      ((ref, inputProps) => (
        <Input
          data-testid="masked-input"
          ref={ref}
          {...props}
          defaultValue={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            inputProps.onChange(e);
            onChange(e);
          }}
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            inputProps.onBlur(e);
            onBlur(e);
          }}
        />
      )) as MaskRender
    }
  />
);

export default MaskedInput;
